import { Grid } from "@mui/material";
import React from "react";
import PosEPaymentsHeader from "./home/header";
import PosEPaymentsTable from "./home/table";

const PosEPayments = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <PosEPaymentsHeader />
      </Grid>
      <Grid item xs={12}>
        <PosEPaymentsTable />
      </Grid>
    </Grid>
  );
};

export default PosEPayments;
